import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import validator from "email-validator";
import { images } from "../utils/images";

//Actions
import {
  requestPasswordReset,
  passwordResetInitiated,
  completePasswordReset,
  pushNotification,
  passwordResetComplete,
} from "../actions/index";

// Components
import ReCAPTCHA from "react-google-recaptcha";

// Icons
import { Visibility, VisibilityOff } from "@material-ui/icons";

const sitekey = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_CAPTCHA_SITEKEY;

function PasswordResetContainer(props) {
  const { t, classes, passResetStarted, passResetComplete } = props;
  const captchaRef = useRef();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confNewPass, setConfNewPass] = useState("");
  const [code, setCode] = useState("");
  const [inputType, changeInputType] = useState("password");
  const [inputType2, changeInputType2] = useState("password");
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [passRequirements, showPassRequirements] = useState(false);
  const [passError, showPassError] = useState(false);
  const [notMatchingPasswords, setMatchingPasswords] = useState(false);
  const [isPasswordInvalid, setPasswordInvalid] = useState(false);
  const [captchaReady, setCaptchaReady] = useState(true);
  const [acquiredCaptcha, setAcquiredCaptcha] = useState(false);
  const [requestingPasswordReset, setRequestingPasswordReset] = useState(false);

  const getCaptcha = async () => {
    setCaptchaReady(false);
    captchaRef.current.reset();
    try {
      await captchaRef.current.executeAsync();
      setAcquiredCaptcha(true);
      setCaptchaReady(true);
    } catch (e) {
      return props.pushNotification({
        message: "Can't connect to Google ReCaptcha",
        type: "error",
      });
    }
  };

  useEffect(() => {
    if (passResetStarted) {
      setStep(2);
    }
  }, [passResetStarted]);

  useEffect(() => {
    if (passResetComplete) {
      setRequestingPasswordReset(false);
      props.passwordResetComplete(false);
      props.passwordResetInitiated(false);
      props.history.push("/id/login");
    }
  }, [passResetComplete]);

  // ComponentDidMount
  useEffect(() => {
    document.body.style.background = "#262626";

    return () => {
      document.body.style.background = "#262626";
      setStep(1);
    };
  }, []);

  const validatePasswords = () => {
    if (newPass === confNewPass) {
      setMatchingPasswords(false);
    } else {
      setMatchingPasswords(true);
    }
  };

  const validatePassRequirements = () => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})");

    if (strongRegex.test(newPass)) {
      showPassRequirements(false);
      showPassError(false);
    } else {
      showPassError(true);
    }
  };

  const togglePassView = (input) => {
    if (input === 1) {
      let type = inputType === "password" ? "text" : "password";
      changeInputType(type);
    } else {
      let type = inputType2 === "password" ? "text" : "password";
      changeInputType2(type);
    }
  };

  const validateEmail = () => {
    setRequestingPasswordReset(true);
    setTimeout(() => {
      setRequestingPasswordReset(false);
    }, 3000);

    let isValidEmail = validator.validate(email);

    if (isValidEmail) {
      let obj = { email: email };

      props.requestPasswordReset(obj);
    } else {
      setRequestingPasswordReset(false);
      setInvalidEmail(true);
    }
  };

  const submitNewPass = async () => {
    if (!acquiredCaptcha) {
      await getCaptcha();
    }

    // if (token === "") {
    //   return props.pushNotification({ message: "captchaEmpty", type: "error" });
    //
    if (captchaRef.current) {
      const token = captchaRef.current.getValue();

      if (token.length) {
        setAcquiredCaptcha(false);
        props.completePasswordReset({
          pass_reset: {
            email: email,
            "g-recaptcha-response": token,
            password_reset_code: code.trim(),
            new_password: newPass,
          },
          callback: setStep,
        });
      }
    }
  };

  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (email.length && !requestingPasswordReset) {
        validateEmail();
      }
    }
  };

  return (
    <div className={classes.passwordResetContainer}>
      <div className={classes.soloLogo}>
        <img src={images.logos.sologenicWhiteLogo} />
      </div>
      <button
        className="exitBtn"
        onClick={() => {
          props.passwordResetInitiated(false);
          props.history.push("/id/login");
        }}
      >
        {t("exit")}
      </button>
      <div className="passwordBox" onKeyDown={(e) => _handleKeyDown(e)}>
        <h2 dangerouslySetInnerHTML={{ __html: t(`passResetTitle${step}`) }} />

        <p className="contentPass">
          {t(`passResetContent${step}`, { email: email })}
        </p>
        {step === 1 ? (
          <p className="warning">{t("_changinPasswordWarningLock")}</p>
        ) : (
          ""
        )}

        {step === 1 ? (
          <input
            type="email"
            onFocus={() => setInvalidEmail(false)}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("enterEmail")}
            className={invalidEmail ? "invalidField" : ""}
            value={email}
          />
        ) : step === 2 ? (
          <input
            type="text"
            onChange={(e) => setCode(e.target.value)}
            placeholder={t("enterVerCode", { email: email })}
            value={code}
          />
        ) : (
          <>
            <input
              type={inputType}
              onChange={(e) => setNewPass(e.target.value)}
              placeholder={t("enterNewPass")}
              onFocus={() => showPassRequirements(true)}
              onBlur={() => validatePassRequirements()}
              className={isPasswordInvalid || passError ? "invalidField" : ""}
            />
            <p
              className="passRequirements notMatch"
              style={
                passError
                  ? { height: "auto", marginTop: 4 }
                  : { height: 0, overflow: "hidden" }
              }
            >
              {t("passError")}
            </p>
            <p
              className="passRequirements"
              style={
                passRequirements
                  ? { height: "auto", marginTop: 4 }
                  : { height: 0, overflow: "hidden" }
              }
            >
              {t("passRequirements")}
            </p>

            <input
              type={inputType2}
              onChange={(e) => setConfNewPass(e.target.value)}
              placeholder={t("confirmNewPass")}
              onBlur={() => validatePasswords()}
              className={notMatchingPasswords ? "invalidField" : ""}
            />
            {notMatchingPasswords ? (
              <p className="passRequirements notMatch">
                {t("passwordsDontMatch")}
              </p>
            ) : (
              ""
            )}
            <ReCAPTCHA
              ref={captchaRef}
              sitekey={sitekey}
              theme="dark"
              size="invisible"
            />
          </>
        )}
        {invalidEmail ? (
          <p className={classes.errorLabel}>{t("invalidEmail")}</p>
        ) : (
          ""
        )}

        {step === 1 ? (
          <button
            onClick={() => validateEmail()}
            disabled={email === "" || requestingPasswordReset ? true : false}
          >
            {t("next")}
          </button>
        ) : step === 2 ? (
          <button
            onClick={() => setStep(3)}
            disabled={code === "" ? true : false}
          >
            {t("next")}
          </button>
        ) : (
          <button onClick={() => submitNewPass()}>{t("confirm")}</button>
        )}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    passResetStarted: state.passResetStarted,
    passResetComplete: state.passResetComplete,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      requestPasswordReset,
      passwordResetInitiated,
      completePasswordReset,
      passwordResetComplete,
      pushNotification,
    },
    dispatch
  );
}

const styles = (theme) => ({
  soloLogo: {
    width: "100%",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 80,

    position: "relative",
    "& img": {
      width: 180,
      height: "auto",
    },
  },
  passwordResetContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: 560,
    width: "95%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: 40,

    "& .exitBtn": {
      alignSelf: "flex-end",
      background: "none",
      color: theme.colors.buttons.sell,
      fontWeight: 500,
      marginBottom: 16,
      cursor: "pointer",
      transition: ".3s",
      fontSize: 18,
      border: "none",
      "&:hover": {
        opacity: 0.5,
      },
    },

    "& .passwordBox": {
      background: theme.colors.background.fore,
      borderRadius: 2,
      boxShadow: theme.defaults.shadow,
      padding: "40px 80px",
      color: theme.colors.text.primary,
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      [theme.breakpoints.down(500)]: {
        padding: "40px 24px",
      },

      "& h2": {
        textAlign: "center",
        fontSize: 28,
        marginBottom: 40,
        "& b": {
          fontWeight: 600,
        },
        [theme.breakpoints.down(400)]: {
          fontSize: 20,
        },
      },

      "& .contentPass": {
        alignSelf: "flex-start",
      },

      "& p": {
        fontSize: 14,
        color: theme.colors.text.secondary,
        // fontFamily: "Titillium Web",
        lineHeight: "21px",
        textAlign: "left",
      },

      "& .warning": {
        color: theme.colors.misc.fail,
        width: "100%",
        marginTop: 12,
      },

      "& input": {
        ...theme.defaults.input,
        marginTop: 16,
        maxWidth: "none",
        "&:nth-of-type(2)": {
          marginBottom: 16,
        },
        "&.invalidField": {
          borderColor: theme.colors.misc.red,
        },
      },
      "& .passRequirements": {
        fontSize: 14,
        // fontFamily: "Titillium Web",
        lineHeight: "21px",
        color: theme.colors.text.secondary,
        "&.notMatch": {
          color: theme.colors.misc.red,
          textAlign: "left",
          marginTop: "-12px",
          marginBottom: 12,
          alignSelf: "flex-start",
        },
      },
      "& button": {
        ...theme.defaults.roundBtn,
        background: theme.colors.buttons.green,
        marginTop: 40,
      },
    },
  },
  errorLabel: {
    color: `${theme.colors.misc.red} !important`,
    alignSelf: "flex-start",
    marginTop: 4,
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(PasswordResetContainer)
  )
);
